import Meta from 'vue-meta';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import qs from 'qs';
import 'vant/lib/index.css'
import VideoPlayer from 'vue-video-player'
import ElementUI from 'element-ui';
import moment from 'moment';
import 'element-ui/lib/theme-chalk/index.css';
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.use(Meta);
Vue.use(ElementUI);

Vue.use(VideoPlayer)
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
Vue.config.productionTip = false
Vue.filter('dateFmt', (input, formatString = "YYYY-MM-DD") => {
  //es5函数参数设置默认值
  //const lastFormatString = formatString || 

  
   // moment(input) 把时间字符串转成时间对象
   // format(formatString) 把时间对象，按照指定格式，格式化成符合条件的字符串
  return moment(input).format(formatString)
})

new Vue({
  router,
  store,
  metaInfo () {
    return {
      title: '新时代语文教育学术展评活动',  // 在这里直接用了同一个title，如果每个页面的title不一样，参考上述链接中的做法
    };
  },
  render: h => h(App)
}).$mount('#app')
